<template>
    <div>
        <section class="hero is-fullheight">
            <div class="hero-body">
                <div class="container has-text-centered is-fluid">
                    <div class="card">
                        <div class="card-content columns is-gapless" style="padding: 0">
                            <div class="column is-8 login-bg">
                                <section class="hero" style="min-height: 100%;">
                                    <div class="hero-body" style="align-items: end">
                                        <div class="container" style="width: auto !important; text-align: left">
                                            <!--<h1 class="title titulo-jogo">{{titulo.toUpperCase()}}</h1><br/>-->
                                            <!--<h2 class="subtitle titulo-jogo">{{subtitulo}}</h2>-->
                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div class="column is-4">
                                <div class="box" style="box-shadow: none">
                                    <h1 class="title titulo-jogo">{{titulo.toUpperCase()}}</h1>
                                    <figure class="avatar">
                                        <img src="../assets/jogador.png" alt="sua foto aqui">
                                    </figure>
                                    <form @submit.prevent="jogar">
                                        <div class="field">
                                            <div class="control">
                                                <label>
                                                    <input class="input is-large" placeholder="Digite seu nome..."
                                                           type="text" required v-model="nomeJogador" maxlength="25"/>
                                                </label>
                                            </div>
                                        </div>

                                        <div class="field">
                                            <div class="control">
                                                <span class="input is-large">************</span>
                                            </div>
                                        </div>
                                        <input type="submit" class="button is-block is-info is-large is-fullwidth"
                                               value="Jogar"/>
                                    </form>
                                </div>
                                <p class="has-text-grey">
                                    <a @click="$root.$children[0].toggleAboutScreen()">Sobre</a> &nbsp;·&nbsp;
                                    <a @click="$root.$children[0].toggleHelpScreen()">Ajuda</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import Flow from '@/components/Flow';

    export default {
        name: 'MainScreen',
        components: {Flow},
        data() {
            return {
                titulo: 'Eu Odeio Comunicação Não-Violenta',
                subtitulo: 'Subtítulo',
                nomeJogador: ''
            }
        },
        mounted() {
            this.nomeJogador = this.$store.state.SaveState.nomeJogador;
        },
        methods: {
            jogar: function () {
                this.$store.commit('setNomeJogador', this.nomeJogador);
                this.$router.push({
                    name: 'GameScreen'
                });
            }
        }
    }
</script>

<!--suppress CssUnusedSymbol -->
<style scoped>
    .login-bg {
        background: linear-gradient(
                rgba(50, 129, 255, 0.45),
                rgba(244, 66, 238, 0.35),
                rgba(66, 238, 244, 0.25)
        ), url('../assets/adult-brunette-communication-920381.jpg') center center;
        /*background: url('../assets/adult-brunette-communication-920381.jpg') center center;*/
        background-size: cover;
    }

    @media screen and (min-width: 768px) {
        .login-bg {
            min-height: 650px;
        }
    }

    @media screen and (min-width: 1400px) {
        .login-bg {
            min-height: 750px;
        }
    }

    @media screen and (min-width: 1601px) {
        .login-bg {
            min-height: 850px;
        }
    }

    html, body {
        font-family: 'Open Sans', serif;
        font-size: 14px;
        font-weight: 300;
    }

    .box {
        margin-top: 2rem;
    }

    .avatar {
        /*margin-top: -70px;*/
        padding-bottom: 20px;
    }

    .avatar img {
        padding: 5px;
        background: #fff;
        border-radius: 50%;
        -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .1);
        box-shadow: 0 2px 3px rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .1);
    }

    input {
        font-weight: 300;
    }

    p {
        font-weight: 700;
    }

    p.subtitle {
        padding-top: 1rem;
    }
</style>
